import React from "react";

// Custom, non-corny wordmark: a concrete block with a precise diamond-blade cut line.
export default function Logo({ className = "", dark = false }) {
  const ink = dark ? "#F5F4F1" : "#161A1D";
  const teal = "#1C6E77";
  return (
    <svg
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="34" height="34" rx="3" stroke={ink} strokeWidth="2" />
      {/* diagonal precision cut */}
      <path d="M9 31 L31 9" stroke={teal} strokeWidth="3" strokeLinecap="round" />
      {/* kerf marks */}
      <path d="M9 22 L18 13" stroke={ink} strokeWidth="1.4" strokeLinecap="round" opacity="0.5" />
      <path d="M22 27 L31 18" stroke={ink} strokeWidth="1.4" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}
